import React, { useState, useEffect } from "react";
import Style from "./TermsandConditions.module.scss";
import { useSelector, useDispatch } from "react-redux";
import Assets from "../Layout/Assets";
import Container from "react-bootstrap/Container";
import Termsofuse from "./TermsofUse/Termsofuse";
import PrivacyPolicy from "../PrivacyPolicy";
import { Link, useLocation, useParams } from "react-router-dom";
function TermsandConditions({ typeId, noHeader }) {
  let location = useLocation();

  const [TermsInsideIndia, setTerms] = useState(true);
  const [activeTab, setActiveTab] = useState(typeId);

  useEffect(() => {
    if (location.pathname.includes("privacy") || typeId === "privacy") {
      setActiveTab("privacy");
    } else {
      setActiveTab("terms");
    }
  }, []);

  return (
    <div className={Style.TermsandConditions_Main}>
      {!noHeader && (
        <div className={Style.TermsandConditions_Top}>
          <Container>
            <h1 className={Style.Top_Head}>Legal</h1>
            <p>
              {/* Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy <br /> eirmod tempor invidunt ut labore et dolore magna
            aliquyam erat, sed diam. */}
            </p>
          </Container>
        </div>
      )}

      <div className={Style.TermsandConditions_Tabs_main}>
        <Container>
          <div className={Style.TermsandConditions_Tabs}>
            <h6
              className={`${Style.Tab} ${
                activeTab == "terms" ? Style.activeClass : ""
              }`}
              onClick={() => setActiveTab("terms")}
            >
              Terms of Use
            </h6>
            <h6
              onClick={() => setActiveTab("privacy")}
              className={`${Style.Tab} ${
                activeTab == "privacy" ? Style.activeClass : ""
              }`}
            >
              Consent
            </h6>
          </div>
        </Container>
      </div>
      <div>
        {activeTab == "terms" ? (
          <Termsofuse TermsInsideIndia={TermsInsideIndia} />
        ) : (
          <PrivacyPolicy />
        )}
      </div>
    </div>
  );
}

export default TermsandConditions;
